<template>
  <div class="video-area" :class="{ 'video-area__h5': isH5 }">
    <div class="video-title" v-if="!isH5">
      <!-- 可开启ai看课 + 可播放视频 -->
      <template v-if="canOpenAIModel && !isShowDialog && lessonInfo.id">
        <!-- 桌面端：此页面只有打开ai，无关闭 -->
        <button
          v-if="!openAiMode || isElectron"
          @click="changeAiMode"
          v-preventReClick
          class="ai-watch-video-btn"
        >
          <img
            class="ai-icon"
            src="../../../assets/images/reply/ai-icon.png"
            alt=""
          />
          AI 看课
        </button>
        <button
          v-else
          v-preventReClick
          @click.stop="changeAiMode"
          class="ai-watch-video-btn"
        >
          <img
            class="ai-icon"
            src="../../../assets/images/reply/ai-icon.png"
            alt=""
          />
          AI 看课
          <img
            class="close-btn"
            src="../../../assets/images/icon/close.png"
            alt=""
          />
        </button>
      </template>
      <div class="name">{{ lessonInfo.lesson_name || "" }}</div>
    </div>
    <div class="video-player-box" ref="videoPlayerBox">
      <template v-if="!isShowDialog && lessonInfo.id">
        <div v-if="isElectron" class="electron-video-cover-wrap">
          <button
            @click="checkLesson(lessonInfo)"
            class="play-btn"
            v-preventReClick
          >
            <img src="../../../assets/images/video-play/play-btn.png" alt="" />
          </button>
          <div class="mask"></div>
          <img
            class="cover"
            :src="
              lessonInfo.cover_url
                ? handleImageUrl(lessonInfo.cover_url)
                : courseInfo.cover_url
            "
            alt=""
          />
        </div>
        <!-- @videoCover="handleVideoCover" -->
        <!-- 网页-普通看课全屏区域 -->
        <div class="video-player-wrap web-normal-mode-fullscreen-cont" v-else>
          <video-player
            ref="videoPlayer"
            :key="lessonInfo.id"
            :lessonInfo="{
              ...lessonInfo,
              risk_control_switch: courseInfo.risk_control_switch,
              risk_control_config: courseInfo.risk_control_config,
              is_sign_up: !!courseInfo.enrollment,
              is_teacher: false,
              is_validity: false,
            }"
            :courseInfo="courseInfo"
            :isComponent="true"
            :jumpPlayTime="jumpPlayTime"
            :componentParams="videoCompParams"
            @fullScreenChange="handleFullScreenChange"
            :openAiMode="openAiMode"
            :initFullScreen="isFullScreen"
            :noteComponentId="noteComponentId"
            @timeupdate="onTimeupdate"
          />
          <!-- 网页-普通看课-全屏时才显示 -->
          <right-lesson-list
            v-if="!isH5"
            v-show="!openAiMode && isFullScreen"
            ref="rightLessonList"
            :openAiMode="openAiMode"
            :initIsShow="false"
            :lesson-info="lessonInfo"
            :course-info="courseInfo"
            @changeLesson="onChangeLesson"
            @changeAiMode="openAiModeChange"
            :noteComponentId="'web-fullscreen-note'"
          />
          <video-slice-full-screen
            class="video-slice-full-screen"
            v-if="!isH5"
            :lesson-info="lessonInfo"
            :playSecond="playTime"
            @jumpPlay="onJumpPlay"
            :videoDuration="getVideoDuration()"
            v-show="openAiMode && isFullScreen"
          ></video-slice-full-screen>
        </div>
      </template>

      <!-- <el-button class="enroll-btn" v-if="!isEnroll && !isShowDialog && lessonInfo.id" @click="handleEnroll">去报名</el-button> -->
      <div class="dialog-box" v-if="isShowDialog">
        <div class="mask"></div>
        <img :src="courseInfo.cover_url + '?imageView2/0/w/700'" alt="" />
        <!-- 防火墙 -->
        <div class="firewall-box dialog-content-box" v-if="showFirewall">
          <div class="tip-text">
            抱歉，该内容无法在网页端观看，可选择以下途径学习
          </div>
          <div class="method-list" v-if="!isH5">
            <div class="method-item">
              <div class="title">
                <img src="../../../assets/images/video-play/step1.png" alt="" />
                <div class="text">使用电脑客户端</div>
              </div>
              <div class="btn-box">
                <div class="have">
                  <div class="text">已安装</div>
                  <div class="btn" @click="runApp">打开客户端</div>
                </div>
                <div class="have">
                  <div class="text">未安装</div>
                  <div class="btn" @click="goDownload">去下载</div>
                </div>
              </div>
            </div>
            <div class="divider"></div>
            <div class="method-item">
              <div class="title">
                <img src="../../../assets/images/video-play/step2.png" alt="" />
                <div class="text">使用手机</div>
              </div>
              <div class="qr">
                <img
                  src="../../../assets//images/video-play/app-qrcode.png"
                  alt=""
                />
              </div>
            </div>
          </div>
          <div class="method-list" v-else>
            <div class="btn-pc">去电脑桌面端</div>
            <div v-if="isWeChat" class="btn-mobile">
              打开 APP
              <wx-open-launch-app
                id="launch-btn"
                appid="wxb509f86149696e36"
                style="
                  position: absolute;
                  left: 0;
                  top: 0;
                  bottom: 0;
                  right: 0;
                  border-radius: 0.32rem;
                "
              >
                <script type="text/wxtag-template">
                  <style>
                    .btn {
                      width: 500px;
                      height: 500px;
                      background: none;
                      border: none;
                    }
                  </style>
                  <button class="btn"></button>
                </script>
              </wx-open-launch-app>
            </div>
            <div v-else class="btn-mobile" @click="runApp('app')">打开 APP</div>
          </div>
        </div>
        <!-- 观看设备类型不对弹窗 -->
        <div
          class="device_type_error dialog-content-box"
          v-else-if="showDeviceTypeError"
        >
          <div class="tip-text">
            该课程设置了仅限{{
              allowDeviceLabel
            }}设备学习，当前设备类型无法观看，请更换设备后学习
          </div>
        </div>
        <!-- 未绑定设备 -->
        <div
          class="no-bind-device dialog-content-box"
          v-else-if="showNoBindDevice"
        >
          <div class="title">提示</div>
          <div class="tip-text">
            该课程仅限绑定设备学习，当前设备未绑定，请先绑定后再学习
          </div>
          <div class="btn-box">
            <el-button @click="goBindDevice" size="small">立即绑定</el-button>
          </div>
        </div>
        <!-- 绑定数量超出提示 -->
        <div
          class="no-bind-device dialog-content-box"
          v-else-if="showBindCountExceed"
        >
          <div class="title">提示</div>
          <div class="tip-text">
            您当前已绑定的设备数量为<span>{{ deviceList.length }}</span
            >超过了课程老师要求的<span>{{ allowedDeviceCount }}</span
            >个，请<span>联系老师</span>解绑<span>{{
              deviceList.length - allowedDeviceCount + 1
            }}</span
            >个设备后，再绑定当前设备观看课程
          </div>
          <!-- <div class="btn-box">
            <el-button @click="goBindDevice" size="small">立即绑定</el-button>
          </div> -->
        </div>
        <!-- 直播预告 -->
        <div
          class="advance-notice dialog-content-box"
          v-else-if="showLiveAdvance"
        >
          <div class="title">
            <div class="tag">直播</div>
            <div class="start-end">
              <span>{{ formatDay(lessonInfo.live_start_time * 1000) }}</span>
              <span
                >{{
                  moment(lessonInfo.live_start_time * 1000).format("HH:mm")
                }}-{{
                  moment(lessonInfo.live_end_time * 1000).format("HH:mm")
                }}</span
              >
            </div>
          </div>
          <div class="remaining-time">
            <p class="days">离开播仅剩 {{ remainingTime.days }} 天</p>
            <div class="time">
              <p>{{ remainingTime.hours }}</p>
              <span>:</span>
              <p>{{ remainingTime.minutes }}</p>
              <span>:</span>
              <p>{{ remainingTime.seconds }}</p>
            </div>
          </div>
          <!-- <div class="course">所属课程：{{ courseInfo.course_name  }}</div> -->
          <div class="btn-box" v-if="!isAuthenticated || !isEnroll">
            <el-button v-if="!isAuthenticated" @click="goLogin"
              >登录后观看</el-button
            >
            <el-button v-else-if="!isEnroll && !isTrial" @click="goEnroll"
              >报名后观看</el-button
            >
          </div>
        </div>
        <!-- 直播未开始 -->
        <div
          class="not-start-box dialog-content-box"
          v-else-if="showNotStartTips"
        >
          <p class="tips">老师正在赶来的路上，请稍作等待…</p>
          <div class="btn-box">
            <el-button v-if="!isAuthenticated" @click="goLogin"
              >登录后观看</el-button
            >
            <el-button v-else-if="!isEnroll && !isTrial" @click="goEnroll"
              >报名后观看</el-button
            >
            <el-button v-else @click="refreshPage">刷新看看</el-button>
          </div>
        </div>
        <!-- 直播进行中 -->
        <div
          class="in-progress-box dialog-content-box"
          v-else-if="showInProgressTips"
        >
          <p class="tips">精彩直播正在进行中…</p>
          <div class="btn-box">
            <el-button v-if="!isAuthenticated" @click="goLogin"
              >登录后观看</el-button
            >
            <el-button v-else-if="!isEnroll && !isTrial" @click="goEnroll"
              >报名后观看</el-button
            >
            <el-button v-else @click="goLiveRoom(lessonInfo)"
              >立即参与</el-button
            >
          </div>
        </div>
        <!-- 点播课-未到发布时间 -->
        <div
          v-else-if="showOnDemandNotPublish"
          class="not-pubilsh-wrap dialog-content-box"
        >
          <div class="title">
            <div class="tag">点播</div>
            <div class="start-end">
              <span>{{ formatDay(lessonInfo.publish_time * 1000) }}</span>
              <span
                >{{ moment(lessonInfo.publish_time * 1000).format("HH:mm") }}-{{
                  moment(
                    (lessonInfo.publish_time + lessonInfo.duration) * 1000
                  ).format("HH:mm")
                }}</span
              >
            </div>
          </div>
          <div class="remaining-time">
            <p class="days">
              距离课时发布还剩
              <span v-if="remainingTime.days">{{ remainingTime.days }} 天</span>
            </p>
            <div class="time">
              <p>{{ remainingTime.hours }}</p>
              <span>:</span>
              <p>{{ remainingTime.minutes }}</p>
              <span>:</span>
              <p>{{ remainingTime.seconds }}</p>
            </div>
          </div>
          <div class="btn-box" v-if="!isAuthenticated || !isEnroll">
            <el-button v-if="!isAuthenticated" @click="goLogin"
              >登录后观看</el-button
            >
            <el-button v-else-if="!isEnroll && !isTrial" @click="goEnroll"
              >报名后观看</el-button
            >
          </div>
        </div>
        <!-- 点播/回放 未登录/未报名-->
        <div
          class="replay-disabled-box dialog-content-box"
          v-else-if="showReplayDisabledTips"
        >
          <img
            src="../../../assets/images//video-play/disabled-play.png"
            alt=""
          />
          <template
            v-if="
              lessonInfo.lesson_type === 1 ||
              ([2, 4].includes(lessonInfo.lesson_type) &&
                liveReplayStatus === 1)
            "
          >
            <div class="course" v-if="!isEnroll">
              所属课程：{{ courseInfo.course_name }}
            </div>
            <div class="btn-box">
              <el-button v-if="!isAuthenticated" @click="goLogin"
                >登录后观看</el-button
              >
              <el-button v-else-if="!isEnroll && !isTrial" @click="goEnroll"
                >报名后观看</el-button
              >
            </div>
          </template>
          <template
            v-else-if="
              [2, 4].includes(lessonInfo.lesson_type) && liveReplayStatus === 2
            "
          >
            <div class="course">
              {{
                lessonInfo.is_record === 1
                  ? "直播回放生成中，请耐心等待"
                  : "暂无视频资源"
              }}
            </div>
          </template>
        </div>
      </div>
    </div>
    <PhoneVerification
      ref="phoneVer"
      @submit="handleBindDevice"
    ></PhoneVerification>
    <BindSuccess
      :show.sync="showBindSuccessVisible"
      title="提示"
      @cancel="refreshPage"
    >
      <div class="bind-success-content">
        <div>设备绑定成功，您可使用绑定的设备观看课程了</div>
        <div class="btn-box">
          <el-button class="btn-item" size="small" @click="refreshPage"
            >我知道了</el-button
          >
        </div>
      </div>
    </BindSuccess>
  </div>
</template>
<script>
import RightLessonList from "@saas/pages/src/learning-center/replay/components/RightLessonList.vue";
import { mapGetters, mapState } from "vuex";
import joinLiveRoomByLessonId from "@saas/components/src/mixins/joinLiveRoomByLessonId";
import wx from "@saas/components/src/mixins/wx";
import VideoPlayer from "./replay/Index.vue";
import protocolCheck from "@saas/components/src/utils/protocol-check";
import moment from "moment";
import { getUserToken, getTeacherToken } from "@saas/server-api/src/live-list";
import { isH5, isHXApp, isWeChat, isMobile } from "@saas/components/src";

import { jsToFlutter } from "@saas/components/src/utils/js-to-flutter";
import { joinLiveRoom, handleImageUrl } from "@saas/components";
import PhoneVerification from "@saas/components/src/components/phone-verification/Index.vue";
import { bindDevice, getDeviceList } from "@saas/server-api/src/device";
import MgDialog from "@saas/components/src/components/mg-dialog/Index.vue";
import { getToken, getRefreshToken } from "@saas/server-api/src/plugins/auth";
import {
  checkLesson,
  getLessonDetail,
} from "@saas/server-api/src/learning-center";
import VideoSliceFullScreen from "../ai-mode/VideoSliceFullScreen.vue";
import { EventBus } from "@saas/components/src/utils/event-bus";
const protocol = process.env.VUE_APP_DESKTOP_PROTOCAL || "comettech://";
export default {
  mixins: [joinLiveRoomByLessonId, wx],
  props: {
    noteComponentId: {
      type: [String, Number],
      default: null,
    },
    lessonInfo: {
      type: Object,
      default: () => {},
    },
    courseInfo: {
      type: Object,
      default: () => {},
    },
    openAiMode: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    VideoPlayer,
    BindSuccess: MgDialog,
    PhoneVerification,
    RightLessonList,
    VideoSliceFullScreen,
  },
  data() {
    return {
      isMobile: isMobile(),
      handleImageUrl,
      moment,
      // 直播剩余时间
      remainingTime: {
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
      },
      // 剩余时间计时器
      remainingTimeInterval: null,
      isElectron: window.isElectron,
      isHXApp: isHXApp(),
      isH5: isH5(),
      isWeChat: isWeChat(),
      deviceList: [],
      showBindSuccessVisible: false,
      isFullScreen: false,
      // 播放时间
      playTime: 0,
      // 跳转播放时间
      jumpPlayTime: 0,
    };
  },
  watch: {
    lessonInfo: {
      handler(newVal) {
        clearInterval(this.remainingTimeInterval);
        this.$nextTick(() => {
          if (this.showLiveAdvance) {
            this.updateRemainingTime();
          }
          if (this.showOnDemandNotPublish) {
            this.updateRemainingTime(1);
          }
        });
      },
      deep: true,
      immediate: true,
    },
    courseInfo: {
      handler() {
        if (this.courseInfo.id) {
          this.getDeviceList();
        }
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    ...mapState("replay", ["canOpenAIModel"]),
    videoCompParams() {
      return {
        courseId: this.courseInfo.id,
        lessonId: this.lessonInfo.id,
        unitId: this.lessonInfo.unit_id,
      };
    },
    userInfo() {
      return this.$store.getters.user || {};
    },
    isShowDialog() {
      return (
        this.showFirewall ||
        this.showLiveAdvance ||
        this.showNotStartTips ||
        this.showInProgressTips ||
        this.showReplayDisabledTips ||
        this.showNoBindDevice ||
        this.showDeviceTypeError ||
        this.showBindCountExceed ||
        this.showOnDemandNotPublish
      );
    },
    // 点播课-未到发布时间
    showOnDemandNotPublish() {
      let now = new Date().getTime();
      let { lesson_type, publish_time = 0 } = this.lessonInfo;
      if (lesson_type === 1 && publish_time * 1000 > now) {
        return true;
      } else {
        return false;
      }
    },
    // 防火墙展示
    showFirewall() {
      // 风险防控打开并且不在客户端内并且没有试听
      return (
        this.isRiskControl &&
        !this.isElectron &&
        !this.isTrial &&
        // !this.isTeacher &&
        this.isAuthenticated &&
        this.isEnroll
      );
    },
    // 观看设备类型不对 提示弹窗
    showDeviceTypeError() {
      if (!this.isAuthenticated || !this.isEnroll || !this.isBindDevice) {
        return false;
      }
      if (this.allowedDevice === 1) {
        // 手机/pad /电脑 /
        // TODO 需要判断pad
        if (this.isElectron || this.isHXApp) {
          return false;
        } else {
          return true;
        }
      } else if (this.allowedDevice === 2) {
        // 手机pad
        // 需要判断pad;
        if (this.isHXApp) {
          return false;
        } else {
          return true;
        }
      } else if (this.allowedDevice === 3) {
        // 电脑
        return !this.isElectron;
      } else {
        return false;
      }
    },
    // 未绑定设备
    showNoBindDevice() {
      if (!this.isAuthenticated || !this.isEnroll || !this.isBindDevice) {
        return false;
      }
      return (
        !this.showDeviceTypeError &&
        !this.isBindCurrentDevice &&
        !this.showBindCountExceed
      );
    },
    // 设备绑定数量超出
    showBindCountExceed() {
      return (
        !this.isBindCurrentDevice &&
        this.deviceList.length >= this.allowedDeviceCount
      );
    },
    // 直播预告展示
    showLiveAdvance() {
      if ([2, 4].includes(this.lessonInfo.lesson_type)) {
        return this.liveTimeStatus === 1 && this.liveRoomStatus === 1;
      } else {
        return false;
      }
    },
    // 直播未开始提示展示(已到可以进入教室时间，但是老师还未创建直播间)
    // TODO 待确认怎么确定老师是否创建直播间
    showNotStartTips() {
      if ([2, 4].includes(this.lessonInfo.lesson_type)) {
        // 直播时间已开始并且未结束， 并且直播间未开始上课
        return this.liveRoomStatus === 1;
      } else {
        return false;
      }
    },
    // 直播进行中提示展示
    showInProgressTips() {
      if ([2, 4].includes(this.lessonInfo.lesson_type)) {
        // 直播时间已开始并且未结束， 并且直播间开始上课未下课
        // return this.liveTimeStatus === 2 && this.liveRoomStatus === 2
        return this.liveRoomStatus === 2;
      } else {
        return false;
      }
    },
    // 点播 / 回放未登录未报名, 回放生成中提示展示
    showReplayDisabledTips() {
      if (
        this.lessonInfo.lesson_type === 1 ||
        ([2, 4].includes(this.lessonInfo.lesson_type) &&
          this.liveRoomStatus === 3)
      ) {
        // 点播或者直播课已经下课
        if (!this.isAuthenticated) {
          // 未登录展示提示
          return true;
        } else {
          if (this.lessonInfo.lesson_type === 1) {
            if (!this.isEnroll && !this.isTrial) {
              return true;
            } else {
              return false;
            }
          } else {
            if (!this.isEnroll && !this.isTrial) {
              return true;
            } else {
              if (this.liveReplayStatus === 2) {
                return true;
              } else {
                return false;
              }
            }
          }
          // 如果已经登录，判断是否报名，如果未报名并且没有试听，需要展示提示
          // if (!this.isEnroll && !this.isTrial) {
          //   return true
          // } else {
          //   return false
          // }
        }
      } else {
        return false;
      }
    },
    // 是否是老师
    isTeacher() {
      return this.courseInfo.is_teacher || false;
    },
    // 是否登录
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
    // 是否需要绑定设备观看
    isBindDevice() {
      if (this.courseInfo.device_bind_switch === 1) {
        if (this.isEnroll) {
          return true;
        } else {
          if (this.isTrial) {
            return false;
          } else {
            return true;
          }
        }
      } else {
        return false;
      }
    },
    // 允许绑定的设备数量
    allowedDeviceCount() {
      return this.courseInfo.risk_control_config?.device_count;
    },
    // 允许观看设备类型
    allowedDevice() {
      if (this.courseInfo.device_bind_switch === 1) {
        if (
          this.courseInfo.risk_control_config.phone === 1 &&
          this.courseInfo.risk_control_config.computer === 1
        ) {
          // 手机 pad 电脑
          return 1;
        } else if (
          this.courseInfo.risk_control_config.phone === 1 &&
          this.courseInfo.risk_control_config.computer === 2
        ) {
          // 手机/pad
          return 2;
        } else {
          // 电脑
          return 3;
        }
      } else {
        return null;
      }
    },
    // 允许观看的设备类型
    allowDeviceLabel() {
      if (this.courseInfo.device_bind_switch === 1) {
        let str = "";
        if (this.courseInfo.risk_control_config.phone === 1) {
          str += "手机/Pad";
        }
        if (this.courseInfo.risk_control_config.computer === 1) {
          if (str) {
            str += "/电脑";
          } else {
            str += "电脑";
          }
        }
        return str;
      } else {
        return "";
      }
    },
    // 是否报名
    isEnroll() {
      return !!this.courseInfo.enrollment;
    },
    // 防火墙风险防控是否开启
    isRiskControl() {
      return (
        this.courseInfo.risk_control_switch === 1 &&
        this.courseInfo.risk_control_config.web_firewall_switch === 1
      );
    },
    // 是否试听
    isTrial() {
      return !!this.lessonInfo.trial_duration;
    },
    // 直播回放生成中
    liveReplayStatus() {
      if (
        [2, 4].includes(this.lessonInfo.lesson_type) &&
        this.liveRoomStatus === 3
      ) {
        // 直播课时并且已经下课
        if (this.lessonInfo.record_url) {
          // 已生成回放
          return 1;
        } else {
          // 回放生成中
          return 2;
        }
      } else {
        return null;
      }
    },
    // 直播间状态
    liveRoomStatus() {
      if ([2, 4].includes(this.lessonInfo.lesson_type)) {
        let { room_start_time, room_end_time } = this.lessonInfo;
        if (room_start_time > 0 && !room_end_time) {
          // 已开始上课，未下课
          return 2;
        } else if (room_end_time > 0) {
          // 已下课
          return 3;
        } else {
          // 未开始上课
          return 1;
        }
      } else {
        return null;
      }
    },
    // 直播时间状态
    liveTimeStatus() {
      if ([2, 4].includes(this.lessonInfo.lesson_type)) {
        let begin = this.lessonInfo.live_start_time;
        let end = this.lessonInfo.live_end_time;
        let now = new Date().getTime();
        // 可提前进入
        if (this.lessonInfo.first_join_time) {
          begin = begin - this.lessonInfo.first_join_time * 60;
        }
        if (end * 1000 < now) {
          // 已结束
          return 3;
        } else if (begin * 1000 > now) {
          // 未开始
          return 1;
        } else {
          // 已开始 未结束
          return 2;
        }
      } else {
        return null;
      }
    },
    // 是否已经绑定当前设备
    isBindCurrentDevice() {
      // TODO 需要判断pad
      if (this.isHXApp || this.isElectron) {
        const deviceId = localStorage.getItem("deviceId");
        return this.deviceList.some(
          (item) => item.device_unique_id === deviceId
        );
      } else {
        return false;
      }
    },
    ...mapGetters(["user"]),
  },
  mounted() {
    this.setVideoPlayerBoxHeight();
    // this.getDeviceList();
    window.addEventListener("resize", this.setVideoPlayerBoxHeight);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.setVideoPlayerBoxHeight);
  },
  methods: {
    getVideoDuration() {
      if (this.$refs.videoPlayer) {
        return this.$refs.videoPlayer.videoDuration;
      } else {
        return 0;
      }
    },
    openAiModeChange(val) {
      // 全屏时打开ai看课，需要关闭全屏
      if (this.isFullScreen) {
        this.$refs.videoPlayer?.toggleFullScreen();
      }
      this.$emit("changeAiMode");
    },
    onChangeLesson(lesson) {
      this.$emit("changeLesson", lesson);
    },
    handleFullScreenChange(val) {
      this.isFullScreen = val;
    },
    changeAiMode() {
      if (this.isElectron) {
        this.checkLesson(this.lessonInfo, true);
      } else {
        this.$emit("changeAiMode");
      }
    },
    playToDuration(duration) {
      if (this.$refs.videoPlayer?.$refs?.dplayer) {
        this.$refs.videoPlayer?.$refs?.dplayer?.playToSeekTime(duration);
      }
    },
    async playVideoInWin(lessonInfo, openAiMode = false) {
      if (!window?.navigator?.onLine) {
        this.$showToast("网络未连接，请稍后再试");
        return false;
      }
      let { id, unit_id } = lessonInfo;
      // ${process.env.VUE_APP_SAAS_WEB_URL}
      let url = `/replay/${this.courseInfo.id}/${unit_id}/${id}?isEnroll=${
        this.isEnroll ? 1 : 0
      }&openAiMode=${openAiMode ? 1 : 0}`;
      // 处理url中的time 参数
      let time = null;
      if (
        this.$route?.query?.time &&
        Number(this.$route?.params?.lessonId) === Number(id)
      ) {
        time = this.$route?.query?.time;
        url = `${url}&time=${time}`;
      }
      let exitUrl = await window.checkWinExist({
        winName: "replayWin",
        isShow: true,
        url: url,
        courseId: this.courseInfo.id,
        unitId: unit_id,
        lessonId: id,
        isEnroll: this.isEnroll,
        openAiMode,
        time,
      });
      if (exitUrl) {
        if (exitUrl !== url) {
          console.log(exitUrl, url, "=====");
        }
      } else {
        // window.open(
        //   url,
        //   "_blank",
        //   `page=replay&refreshToken=${getRefreshToken()}&token=${getToken()}`
        // );
        window.ipcRenderer.send("create-new-win", {
          key: "replayWin",
          url,
        });
      }
      console.log("emit-video-play-note-disabled", {
        lessonId: id,
      });
      EventBus.$emit("video-play-note-disabled", {
        lessonId: id,
      });
    },
    checkLesson(lessonInfo, openAiMode = false) {
      this.$emit("saveNote");
      checkLesson({
        course_id: this.courseInfo.id,
        lesson_id: lessonInfo.id,
      }).then((res) => {
        if (res.code === 1) {
          this.playVideoInWin(lessonInfo, openAiMode);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 设置视频播放区域高度
    setVideoPlayerBoxHeight() {
      this.$nextTick(() => {
        setTimeout(() => {
          if (this.isH5) {
            return;
          }
          // 添加安全检查
          if (!this.$refs.videoPlayerBox) {
            console.warn("videoPlayerBox ref not ready");
            return;
          }
          //  获取vidoePlayerbox宽度
          let width = this.$refs.videoPlayerBox.clientWidth;
          let height = (width / 16) * 9;
          this.$refs.videoPlayerBox.style.height = height + "px";
          this.$emit("videoPlayerBoxHeight", height);
        }, 300);
      });
    },
    // 格式化日期
    formatDay(day) {
      const now = moment();
      const lessonMoment = moment(day);

      if (lessonMoment.isSame(now, "day")) {
        return `今天`;
      } else if (lessonMoment.isSame(now.add(1, "day"), "day")) {
        return `明天`;
      } else {
        return `${lessonMoment.format("MM月DD日")}`;
      }
    },
    getTimeDifference(targetDate) {
      const now = new Date();
      const target = new Date(targetDate);

      // 计算时间差（毫秒）
      const diff = target - now;

      if (diff <= 0) {
        return {
          days: 0,
          hours: 0,
          minutes: 0,
          seconds: 0,
        };
      }

      // 计算天数
      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      // 计算剩余的小时数
      const hours = Math.floor(
        (diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      // 计算剩余的分钟数
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      // 计算剩余的秒数
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);
      return {
        days: days,
        hours: hours < 10 ? "0" + hours : hours,
        minutes: minutes < 10 ? "0" + minutes : minutes,
        seconds: seconds < 10 ? "0" + seconds : seconds,
      };
    },
    updateRemainingTime(courseType = 2) {
      console.log("updateRemainingTime");

      clearInterval(this.remainingTimeInterval);
      this.remainingTimeInterval = setInterval(() => {
        if (courseType === 1) {
          // 点播
          this.remainingTime = this.getTimeDifference(
            this.lessonInfo.publish_time * 1000
          );
        } else {
          // 直播
          this.remainingTime = this.getTimeDifference(
            this.lessonInfo.live_start_time * 1000 -
              this.lessonInfo.first_join_time * 60 * 1000
          );
        }

        if (
          +this.remainingTime.days === 0 &&
          +this.remainingTime.hours === 0 &&
          +this.remainingTime.minutes === 0 &&
          +this.remainingTime.seconds === 0
        ) {
          clearInterval(this.remainingTimeInterval);
          setTimeout(() => {
            this.$router.go(0);
          }, 1000);
          // this.$router.replace({
          //   path: `/video-play/${this.courseInfo.id}/${this.lessonInfo.unit_id}/${this.lessonInfo.id}` ,
          // });
        }
      }, 1000);
    },
    // 处理直播间状态
    handleRoomStatus(item) {
      let { room_start_time, room_end_time } = item;
      if (room_start_time > 0 && !room_end_time) {
        item.roomStatus = 2;
        item.roomStatusText = "上课中";
      } else if (room_end_time > 0) {
        item.roomStatus = 3;
        item.roomStatusText = "已下课";
      } else {
        item.roomStatus = 1;
        item.roomStatusText = "未开始";
      }
    },
    handleLiveStatus(item) {
      let begin = item.live_start_time;
      let end = item.live_end_time;
      let now = new Date().getTime();
      // 可提前进入
      if (item.first_join_time) {
        begin = begin - item.first_join_time * 60;
      }
      if (end * 1000 < now) {
        // 已结束
        item.status = 3;
      } else if (begin * 1000 > now) {
        // 未开始
        item.status = 1;
      } else {
        // 已开始
        item.status = 2;
      }
    },
    // 直播课提示信息
    handleLiveTips(lesson) {
      if (lesson.record_url) {
        lesson.liveStatus = 1;
        lesson.tips = "观看视频";
      } else if (lesson.roomStatus === 3) {
        lesson.liveStatus = 2;
        lesson.tips = "回放生成中";
      } else if (lesson.status === 2 || lesson.roomStatus === 2) {
        // 直播间开始上课|到后台设置的课程开始时间
        lesson.liveStatus = 3;
        lesson.tips = "进入教室";
      } else if (lesson.status === 1 && lesson.first_join_time) {
        lesson.liveStatus = 4;
        lesson.tips = `提前${lesson.first_join_time}分钟才可进入`;
      }
    },
    // 打开客户端
    runApp(type) {
      const url = `${protocol}openpage/video-play/${this.courseInfo.id}/${this.lessonInfo.unit_id}/${this.lessonInfo.id}`;
      if (type === "app") {
        window.location.href = url;
      } else {
        protocolCheck(url, () => {
          // this.goDownload();
          // this.$message.error("打开客户端失败，请手动打开魔果云课客户端");
        });
      }
    },
    // go to download page
    goDownload() {
      this.$router.push("/download");
    },
    // 登录
    goLogin() {
      if (window.isElectron) {
        this.$router.push({
          name: "LoginPage",
        });
      } else {
        this.$loginDialog();
      }
    },
    // 报名 打开课程的商品详情页
    goEnroll() {
      const url = `/product-detail/${this.courseInfo.id}`;
      if (window.isElectron || this.isMobile) {
        this.$router.push(url);
      } else {
        window.open(url);
      }
    },
    // 非全屏时，在新标签页打开课程的商品详情页
    // 全屏时，变为非全屏，再在新标签页打开课程的商品详情页
    handleEnroll() {
      if (window.isElectron || this.isMobile) {
        this.$router.push(`/product-detail/${this.courseInfo.id}`);
      } else {
        window.open(`/product-detail/${this.courseInfo.id}`);
      }
    },
    // 刷新页面
    refreshPage() {
      this.$router.go(0);
    },
    stopLoading() {
      this.$saasLoadingClose();
      // console.log("stopLoading--3");
      // this.loading && this.loading.close();
    },
    async goLiveRoom(obj) {
      let params = {
        course_id: obj.course_id,
        lesson_id: obj.id,
      };
      if (this.isAuthenticated) {
        // 登录
        try {
          this.$saasLoadingShow();
          // this.loading = this.$loading({
          //   lock: true,
          //   text: "进入教室中",
          //   spinner: "el-icon-loading",
          //   background: "rgba(255,255,255,.6)",
          //   fullscreen: true,
          // });
          // todo: 判断是老师还是学生？？
          let res = await getLessonDetail(params);
          let fn = getUserToken;
          let tokenParams = {
            course_id: obj.course_id,
            lesson_id: obj.id,
          };
          if (res?.code === 1) {
            let { is_teacher, mode } = res.data;
            if (is_teacher) {
              fn = getTeacherToken;
            }
            fn(tokenParams).then((res) => {
              if (res.code === 1) {
                let {
                  room_id = "",
                  token = "",
                  user_id = "",
                  is_teacher = false,
                  risk_control_switch,
                  risk_control_config = {},
                  is_lesson_teacher,
                  is_lesson_assistant,
                } = res.data;
                let { course_id = "", id = "" } = obj;
                const disableRecord =
                  risk_control_switch === 1 &&
                  risk_control_config.recording_screen_switch === 1
                    ? 1
                    : 0;
                if (this.isHXApp) {
                  let params = {
                    room_id,
                    user_id,
                    course_id,
                    lesson_id: id,
                    token,
                    disableRecord,
                  };
                  jsToFlutter("joinLiveRoom", params);
                  this.$saasLoadingClose();
                } else {
                  let liveParams = {
                    classid: room_id,
                    userid: user_id,
                    courseid: course_id,
                    lessonid: id,
                    token: token,
                    disableRecord,
                    mode: mode,
                    isNewLive: obj.is_new_live,
                    isTeacher: is_lesson_teacher,
                    isAssistant: is_lesson_assistant,
                  };
                  joinLiveRoom(liveParams);
                }
              } else if (res.code === 40007) {
                // 开启网页防火墙
                this.$router.replace("/firewall/" + this.courseInfo.id);
                this.$saasLoadingClose();
              } else {
                this.$message.error(res.message);
                this.$saasLoadingClose();
              }
            });
          } else {
            this.$message.error(res.message);
            this.$saasLoadingClose();
          }
        } catch (error) {
          this.$saasLoadingClose();
        }
      } else {
        // 未登录
        this.jumpLoginPage();
      }
    },
    handleBindDevice(data) {
      bindDevice({
        code: data.code,
        org_id: this.courseInfo.org_id,
      }).then((res) => {
        if (res.code === 1) {
          this.$message.success("绑定成功");
          this.$refs.phoneVer.close();
          this.showBindSuccessVisible = true;
          // this.refreshPage();
        } else {
          this.$message.error(res.message);
        }
      });
      // this.$refs.bindDevice.open();
    },
    // 获取设备列表
    getDeviceList() {
      getDeviceList({
        org_id: this.courseInfo.org_id,
      }).then((res) => {
        if (res.code === 1) {
          this.deviceList = res.data || [];
        }
      });
    },
    // 去绑定
    goBindDevice() {
      this.$refs.phoneVer.open();
    },
    // 播放器播放时间更新
    onTimeupdate(time) {
      this.playTime = time;
    },
    // 播放器跳转播放
    onJumpPlay(time) {
      // this.jumpPlayTime = time;
      this.$refs.videoPlayer.jumpTime(time);
    },
  },
};
</script>

<style scoped lang="scss">
.video-area {
  // background-color: red;
  flex: 1;
  // height: 100%;
  .video-title {
    width: 100%;
    height: 60px;
    line-height: 60px;
    background: linear-gradient(
      135deg,
      rgba(244, 255, 248, 0.8) 0%,
      rgba(254, 254, 255, 0.8) 87%,
      rgba(249, 251, 255, 0.8) 100%
    );
    border-radius: 6px 6px 0px 0px;
    border: 1px solid #ffffff;
    display: flex;
    align-items: center;
    padding-left: 12px;
    padding-right: 20px;
    .ai-watch-video-btn {
      margin-right: 8px;
      padding-right: 4px;
      min-width: 80px;
      width: max-content;
      height: 28px;
      background: #ffffff;
      border-radius: 6px;
      border: 1px solid #ffffff;
      font-weight: 500;
      font-size: 14px;
      color: #232a18;
      line-height: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      &:disabled {
        opacity: 1;
      }
      .ai-icon {
        width: 28px;
        height: 28px;
      }
      .close-btn {
        width: 14px;
        height: 14px;
        margin-left: 6px;
        margin-right: 2px;
      }
    }
    .name {
      flex: 1;
      height: 100%;
      background-image: url("../../../assets/images/video-play/logo.png");
      background-repeat: no-repeat;
      background-position: right top;
      background-size: 70px 52px;
      font-weight: 500;
      font-size: 16px;
      color: #0d1400;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1;
      word-break: break-all;
    }
  }
  .video-player-box {
    height: 480px;
    position: relative;
    border-radius: 0 0 6px 6px;
    overflow: hidden;
    width: 100%;
    .video-player-wrap {
      display: flex;
      height: 100%;
      .video-slice-full-screen {
        position: absolute;
        right: 12px;
        top: 60px;
        bottom: 165px;
      }
    }
    .dialog-box {
      width: 100%;
      height: 100%;
      overflow: hidden;
      position: relative;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
      .mask {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.8);
      }
      .dialog-content-box {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 100;
      }
      .firewall-box {
        width: 510px;
        height: 250px;
        background: #fff;
        border-radius: 12px;
        padding: 24px 0px;
        .tip-text {
          padding-left: 30px;
          font-weight: 400;
          font-size: 12px;
          color: #515350;
          line-height: 17px;
        }
        .method-list {
          margin-top: 30px;
          display: flex;
          flex-direction: row;
          .method-item {
            &:first-child {
              margin-left: 26px;
            }
            .title {
              display: flex;
              flex-direction: row;
              img {
                width: 22px;
                height: 22px;
              }
              .text {
                font-weight: 500;
                font-size: 16px;
                color: #0d1400;
                line-height: 22px;
              }
            }
            .btn-box {
              display: flex;
              flex-direction: row;
              margin-top: 12px;
              .have {
                width: 106px;
                height: 100px;
                background: #f6f6f6;
                border-radius: 12px;
                text-align: center;
                &:first-child {
                  margin-left: 26px;
                }
                &:last-child {
                  margin-left: 16px;
                }
                .text {
                  margin-top: 25px;
                  font-weight: 500;
                  font-size: 14px;
                  color: #0d1400;
                  line-height: 20px;
                }
                .btn {
                  cursor: pointer;
                  margin: 0 auto;
                  margin-top: 14px;
                  width: 92px;
                  height: 34px;
                  line-height: 34px;
                  text-align: center;
                  border: 1px solid rgba(0, 232, 132, 0.2);
                  font-weight: 600;
                  font-size: 14px;
                  color: #ffffff;
                  background: linear-gradient(
                    41.94400710581127deg,
                    #00eb81 0%,
                    #00c89d 100%
                  );
                  -webkit-background-clip: text;
                  -webkit-text-fill-color: transparent;
                  background-clip: text;
                  border-radius: 8px;
                }
              }
            }
            .qr {
              margin-left: 22px;
              margin-top: 12px;
              width: 98px;
              height: 98px;
              background: #f6f6f6;
              border-radius: 12px;
              display: flex;
              justify-content: center;
              align-items: center;
              img {
                width: 84px;
                height: 84px;
              }
            }
          }
          .divider {
            margin-left: 39px;
            margin-right: 20px;
            width: 1px;
            height: 158px;
            background: #f6f6f6;
          }
        }
      }
      .device_type_error {
        width: 380px;
        background: #fff;
        border-radius: 18px;
        padding: 24px;
        font-weight: 400;
        font-size: 14px;
        color: #515350;
        line-height: 22px;
      }
      .no-bind-device {
        width: 380px;
        background: #fff;
        border-radius: 18px;
        padding: 24px;
        text-align: center;
        .title {
          margin-bottom: 22px;
          font-weight: 500;
          font-size: 14px;
          color: #0d1400;
          line-height: 22px;
          text-align: center;
        }
        .tip-text {
          font-weight: 400;
          font-size: 14px;
          color: #515350;
          line-height: 22px;
          text-align: center;
          span {
            color: #f03349;
          }
        }
        .btn-box {
          margin-top: 14px;
        }
      }
      .advance-notice,
      .not-pubilsh-wrap {
        width: 360px;
        height: 222px;
        background: #ffffff;
        border-radius: 14px;
        padding: 0 48px;
        .title {
          margin-top: 36px;
          display: flex;
          flex-direction: row;
          align-items: center;
          .tag {
            width: 44px;
            height: 24px;
            line-height: 22px;
            text-align: center;
            border-radius: 5px;
            border: 1px solid rgba(240, 51, 73, 0.3);
            font-weight: 400;
            font-size: 16px;
            color: #f03349;
            margin-right: 6px;
          }
          .start-end {
            font-weight: 500;
            font-size: 20px;
            color: #0d1400;
            line-height: 28px;
            span {
              &:last-child {
                margin-left: 6px;
              }
            }
          }
        }
        .remaining-time {
          margin-top: 13px;
          display: flex;
          flex-direction: row;
          align-items: center;
          .days {
            font-weight: 400;
            font-size: 14px;
            color: #515350;
            line-height: 20px;
          }
          .time {
            margin-left: 11px;
            color: #f03349;
            display: flex;
            font-size: 14px;
            p {
              width: 22px;
              height: 22px;
              font-weight: 500;
              line-height: 22px;
              text-align: center;
              background: #ffeff1;
              border-radius: 5px;
            }
            span {
              font-weight: 500;
              margin: 0 5px;
            }
          }
        }
        .course {
          margin-top: 7px;
          font-weight: 400;
          font-size: 14px;
          color: #515350;
          line-height: 20px;
          overflow: hidden;
          text-overflow: ellipsis;
          word-break: break-all;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
        }
        .btn-box {
          margin-top: 31px;
          text-align: center;
          .el-button {
            width: 120px;
            height: 40px;
            padding-top: 0;
            padding-bottom: 0;
          }
        }
      }
      .not-start-box,
      .in-progress-box {
        text-align: center;
        .tips {
          font-weight: 500;
          font-size: 16px;
          color: #ffffff;
          line-height: 22px;
          margin-bottom: 20px;
        }
        .el-button {
          width: 100px;
          height: 32px;
          padding: 0;
          font-size: 14px;
        }
      }
      .replay-disabled-box {
        text-align: center;
        img {
          display: inline-block;
          width: 30px;
          height: 30px;
        }
        .course {
          width: 100%;
          margin-top: 10px;
          font-weight: 500;
          font-size: 16px;
          color: #ffffff;
          line-height: 22px;
          overflow: hidden;
          text-overflow: ellipsis;
          word-break: break-all;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
        }
        .el-button {
          margin-top: 18px;
          width: 100px;
          text-align: center;
          height: 32px;
          padding: 0;
          font-size: 14px;
        }
      }
    }
    .enroll-btn {
      position: absolute;
      right: 30px;
      top: 30px;
      padding: 0;
      width: 90px;
      height: 40px;
      border: none;
      background: linear-gradient(135deg, #ff7a00 0%, #ff27c0 100%);
      border-radius: 10px;
      font-size: 16px;
      color: #fff;
      z-index: 9999;
    }
  }
}
.video-area__h5 {
  // background-color: red;
  flex: 1;
  height: 100%;
  height: 5.6rem;
  .video-player-wrap,
  .page-container {
    width: 100%;
  }
  .video-player-box {
    position: relative;
    width: 100%;
    height: 100%;
    height: 5.6rem;
    .dialog-box {
      width: 100%;
      height: 100%;
      overflow: hidden;
      position: relative;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
      .mask {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.8);
      }
      .dialog-content-box {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 100;
      }
      .firewall-box {
        width: 6.9333rem;
        height: 3.44rem;
        background: #fff;
        border-radius: 0.48rem;
        padding: 0.4rem 0px;
        .tip-text {
          padding: 0 0.4rem;
          font-weight: 400;
          font-size: 0.3733rem;
          color: #515350;
          line-height: 0.5867rem;
        }
        .method-list {
          margin-top: 0.5333rem;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          padding: 0 0.4rem;
          div {
            width: 2.9333rem;
            height: 0.96rem;
            border-radius: 0.2133rem;
            font-weight: 500;
            font-size: 0.3733rem;
            color: #ffffff;
            line-height: 0.96rem;
            text-align: center;
            cursor: pointer;
          }
          .btn-mobile {
            position: relative;
            color: #fff;
            background: linear-gradient(135deg, #00eb81 0%, #00c89d 100%);
            overflow: hidden;
          }
          .btn-pc {
            color: #1d2129;
          }
        }
      }
      .advance-notice,
      .not-pubilsh-wrap {
        width: 7.9467rem;
        height: 4.0267rem;
        background: #ffffff;
        border-radius: 0.3733rem;
        padding: 0 0.48rem;
        .title {
          margin-top: 0.56rem;
          display: flex;
          flex-direction: row;
          align-items: center;
          .tag {
            width: 0.96rem;
            height: 0.5333rem;
            line-height: 0.5067rem;
            text-align: center;
            border-radius: 0.1333rem;
            border: 1px solid rgba(240, 51, 73, 0.3);
            font-weight: 400;
            font-size: 0.32rem;
            color: #f03349;
            margin-right: 0.2133rem;
          }
          .start-end {
            font-weight: 500;
            font-size: 0.4267rem;
            color: #0d1400;
            line-height: 0.5867rem;
            span {
              &:last-child {
                margin-left: 0.2133rem;
              }
            }
          }
        }
        .remaining-time {
          margin-top: 0.2933rem;
          display: flex;
          flex-direction: row;
          align-items: center;
          .days {
            font-weight: 400;
            font-size: 0.3733rem;
            color: #515350;
            line-height: 0.5333rem;
          }
          .time {
            margin-left: 0.2933rem;
            color: #f03349;
            display: flex;
            align-items: center;
            font-size: 0.3867rem;
            p {
              width: 0.5867rem;
              height: 0.5867rem;
              font-weight: 500;
              line-height: 0.5867rem;
              text-align: center;
              background: #ffeff1;
              border-radius: 0.1333rem;
            }
            span {
              font-weight: 500;
              margin: 0 0.1067rem;
            }
          }
        }
        .course {
          margin-top: 0.2133rem;
          font-weight: 400;
          font-size: 0.3733rem;
          color: #515350;
          line-height: 0.5333rem;
          overflow: hidden;
          text-overflow: ellipsis;
          word-break: break-all;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
        }
        .btn-box {
          margin-top: 0;
          text-align: center;
          .el-button {
            width: 2.1333rem;
            height: 0.7467rem;
            padding-top: 0;
            padding-bottom: 0;
            padding: 0;
          }
        }
      }
      .device_type_error {
        width: 9.3333rem;
        background: #fff;
        border-radius: 0.48rem;
        padding: 0.64rem;
        font-weight: 400;
        font-size: 0.3733rem;
        color: #515350;
        line-height: 0.5867rem;
      }
      .no-bind-device {
        width: 8.8rem;
        background: #fff;
        border-radius: 0.48rem;
        padding: 0.64rem;
        text-align: center;
        .title {
          margin-bottom: 0.5867rem;
          font-weight: 500;
          font-size: 0.3733rem;
          color: #0d1400;
          line-height: 0.5867rem;
          text-align: center;
        }
        .tip-text {
          font-weight: 400;
          font-size: 0.3733rem;
          color: #515350;
          line-height: 0.5867rem;
          text-align: center;
          span {
            color: #f03349;
          }
        }
        .btn-box {
          margin-top: 0.3733rem;
        }
      }
      .not-start-box,
      .in-progress-box {
        text-align: center;
        width: 90%;
        .tips {
          font-weight: 500;
          font-size: 0.4267rem;
          color: #ffffff;
          line-height: 0.5867rem;
          margin-bottom: 0.2667rem;
        }
        .el-button {
          width: 2.6667rem;
          height: 0.8533rem;
          padding-top: 0;
          padding-bottom: 0;
          font-size: 0.3733rem;
        }
      }
      .replay-disabled-box {
        text-align: center;
        img {
          display: inline-block;
          width: 0.8rem;
          height: 0.8rem;
        }
        .course {
          width: 100%;
          margin-top: 10px;
          font-weight: 500;
          font-size: 0.4267rem;
          color: #ffffff;
          line-height: 0.5867rem;
          overflow: hidden;
          text-overflow: ellipsis;
          word-break: break-all;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
        }
        .el-button {
          margin-top: 0.3733rem;
          width: 2.6667rem;
          text-align: center;
          height: 0.8533rem;
          padding: 0;
          font-size: 0.3733rem;
        }
      }
    }
    .enroll-btn {
      position: absolute;
      right: 30px;
      top: 30px;
      padding: 0;
      width: 90px;
      height: 40px;
      border: none;
      background: linear-gradient(135deg, #ff7a00 0%, #ff27c0 100%);
      border-radius: 10px;
      font-size: 16px;
      color: #fff;
      z-index: 9999999;
    }
  }
  .el-button {
    border: none;
    background: linear-gradient(135deg, #00eb81 0%, #00c89d 100%);
    border-radius: 0.16rem;
    font-size: 0.3733rem;
    color: #fff;
  }
}
.bind-success-content {
  text-align: center;
  .btn-box {
    margin-top: 30px;
  }
}
.el-button {
  border: none;
  background: linear-gradient(135deg, #00eb81 0%, #00c89d 100%);
  border-radius: 10px;
  font-size: 16px;
  color: #fff;
}

// electron
.electron-video-cover-wrap {
  position: relative;
  width: 100%;
  height: 100%;
  .play-btn {
    position: absolute;
    z-index: 2;
    width: 80px;
    height: 80px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    img {
      width: 100%;
      height: 100%;
    }
  }
  .mask {
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba($color: #191919, $alpha: 0.4);
  }
  .cover {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
</style>
